import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { getRpmDeviceTypeLabel } from '../../constants/other';
import {
    getTopProgramChipLabel,
    getProgramChipStyle,
    getRpmEligibleChipStyle,
    shouldShowRpmAddonProgramPill,
    getRpmAddonProgramPillLabel,
    shouldShowRpmDeviceTypeForLookup,
} from '../../utils/programChipHelpers';

const PatientLookupProgramCell = ({ data, rpmDeviceTypes, isCne }) => {
    if (!data) {
        return null;
    }

    const programLabel = getTopProgramChipLabel(data);
    const showRpmPill = shouldShowRpmAddonProgramPill(data.rpm_addon_status_id);
    const rpmPillLabel = getRpmAddonProgramPillLabel(data.rpm_addon_status_id);
    const showDeviceLine = shouldShowRpmDeviceTypeForLookup(data.rpm_addon_status_id);
    const deviceLabel = getRpmDeviceTypeLabel(rpmDeviceTypes, data.rpm_device_type_id);

    let apcmCandidate = false;
    let apcmPatient = false;
    if (data.program_type === 'apcm') {
        apcmPatient = true;
    } else if (data.program_type === 'ccm') {
        if (data.apcm_enrollment === 'Candidate' && data.apcm_eligible_level) {
            apcmCandidate = true;
        }
    }

    return (
        <div>
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                {programLabel &&
                    <span style={getProgramChipStyle(programLabel)}>{programLabel}</span>
                }
                {showRpmPill && rpmPillLabel &&
                    <span style={getRpmEligibleChipStyle()}>{rpmPillLabel}</span>
                }
            </div>
            {showDeviceLine && deviceLabel &&
                <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                    Device: {deviceLabel}
                </div>
            }
            {(apcmPatient || apcmCandidate) &&
                <div className="value-box" style={{ width: '100%', display: 'flex', flex: 1, flexDirection: 'column' }}>
                    {!isCne &&
                        <div style={{ display: 'flex', justifyContent: 'flex-start', padding: 0 }}>
                            <span style={{ fontWeight: 400 }}>APCM Service Level:</span>
                            <span style={{ paddingLeft: 15 }}>{data.apcm_service_level ? data.apcm_service_level : '-'}</span>
                        </div>
                    }
                    <div style={{ display: 'flex', justifyContent: 'flex-start', padding: 0 }}>
                        <span style={{ fontWeight: 400 }}>APCM Eligible Level:</span>
                        <span style={{ paddingLeft: 15 }}>{data.apcm_eligible_level ? data.apcm_eligible_level : '-'}</span>
                    </div>
                    {data.call_due_date &&
                        <div style={{ display: 'flex', justifyContent: 'flex-start', padding: 0 }}>
                            <span style={{ fontWeight: 400 }}>APCM Target Date:</span>
                            <span style={{ paddingLeft: 15 }}>
                                {data.call_due_date ? moment(data.call_due_date).format('MM/DD/YYYY') : '-'}
                            </span>
                        </div>
                    }
                </div>
            }
        </div>
    );
};

const mapStateToProps = (state) => ({
    rpmDeviceTypes: state.queue.rpmDeviceTypes,
});

export default connect(mapStateToProps)(PatientLookupProgramCell);
